
// Jannaty — Premium Interactions
(function() {
  'use strict';

  // Custom Cursor
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const dot = document.createElement('div');
    const ring = document.createElement('div');
    dot.className = 'j-cursor j-cursor-dot';
    ring.className = 'j-cursor j-cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    let mx = -100, my = -100, rx = -100, ry = -100;

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    });

    function animateRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    document.querySelectorAll('a, button, [role="button"], .card, .collection-list__item, summary').forEach(function(el) {
      el.addEventListener('mouseenter', function() { document.body.classList.add('j-cursor--hover'); });
      el.addEventListener('mouseleave', function() { document.body.classList.remove('j-cursor--hover'); });
    });
  }

  // Scroll Reveal
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.j-scroll-reveal').forEach(function(el) { obs.observe(el); });

  // Sticky header class
  var header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // Shipping bar confetti on threshold
  function spawnConfetti(container) {
    var colors = ['#736e5a','#ddd3cc','#c9a96e','#8d8773'];
    for (var i = 0; i < 12; i++) {
      var p = document.createElement('div');
      p.className = 'confetti-piece';
      p.style.cssText = 'left:' + Math.random()*100 + '%;background:' + colors[Math.floor(Math.random()*colors.length)] + ';animation-delay:' + (Math.random()*0.4) + 's;animation-duration:' + (0.8+Math.random()*0.6) + 's;';
      container.appendChild(p);
      setTimeout(function() { if (p.parentNode) p.parentNode.removeChild(p); }, 2000);
    }
  }

  var shippingBar = document.querySelector('.jannaty-shipping-bar');
  if (shippingBar) {
    var confettiFired = false;
    document.addEventListener('cart:updated', function(e) {
      var total = e.detail && e.detail.total_price ? e.detail.total_price / 100 : 0;
      if (total >= (window.jnShipThreshold || 49.90) - 0.001 && !confettiFired) {
        confettiFired = true;
        spawnConfetti(shippingBar);
      }
    });
  }

})();


// ── Logo high-res fix ─────────────────────────────────────────────────────
// Shopify CDN loads logo at ?height=100 max. We patch src to ?height=600
// using MutationObserver so it works even with Horizon web component init.
(function () {
  var HIRES = 600;
  function patchLogo() {
    var img = document.querySelector('img.header-logo__image');
    if (!img) return false;
    var src = img.getAttribute('src') || '';
    if (src.indexOf('height=' + HIRES) !== -1) return true; // already patched
    if (src.indexOf('height=') !== -1) {
      img.setAttribute('src', src.replace(/height=d+/, 'height=' + HIRES));
    } else if (src.indexOf('?') !== -1) {
      img.setAttribute('src', src + '&height=' + HIRES);
    }
    img.setAttribute('srcset', '');
    img.removeAttribute('width');
    img.removeAttribute('height');
    return true;
  }

  // Try immediately
  if (!patchLogo()) {
    // Watch for DOM changes (Horizon hydration)
    var obs = new MutationObserver(function () {
      if (patchLogo()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
    // Fallback timeout
    setTimeout(function () { patchLogo(); obs.disconnect(); }, 3000);
  }
})();
